/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * Objects of type TestMessage are sent to hub method named testMessage Listen to it via `signalRHub.on("testMessage", (message: TestMessage) => {}`
 * Currently a timer emits a message on this method to all clients once a minute, as a demo.
 * @export
 * @interface TestMessage
 */
export interface TestMessage {
    /**
     *
     * @type {string}
     * @memberof TestMessage
     */
    connectionId?: string;
    /**
     *
     * @type {string}
     * @memberof TestMessage
     */
    sender?: string;
    /**
     *
     * @type {string}
     * @memberof TestMessage
     */
    text?: string;
}

/**
 * Check if a given object implements the TestMessage interface.
 */
export function instanceOfTestMessage(value: object): value is TestMessage {
    return true;
}

export function TestMessageFromJSON(json: any): TestMessage {
    return TestMessageFromJSONTyped(json, false);
}

export function TestMessageFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): TestMessage {
    if (json == null) {
        return json;
    }
    return {
        connectionId:
            json["connectionId"] == null ? undefined : json["connectionId"],
        sender: json["sender"] == null ? undefined : json["sender"],
        text: json["text"] == null ? undefined : json["text"],
    };
}

export function TestMessageToJSON(value?: TestMessage | null): any {
    if (value == null) {
        return value;
    }
    return {
        connectionId: value["connectionId"],
        sender: value["sender"],
        text: value["text"],
    };
}
